module.exports = __webpack_public_path__ + "cb1ff8bc71b32e3ade72cc7de90bc3c1.png";